import React from 'react';

import { DragArea } from './DragArea';

import styled from 'styled-components';
import { Vector } from './JRCInputColorRawProps';
import { colorimetry } from 'utils/utils.color';

const RANGE_HEIGHT = 12;

export const CSSColorRangeWrapper = styled.div`
    position: relative;
    pointer-events: none;
    border-radius: ${RANGE_HEIGHT}px;
    overflow: hidden;
`;

export const CSSColorRangeBackground = styled.div<{ width: number; height: number }>`
    width: ${(props) => props.width}px;
    height: ${(props) => props.height}px;
    pointer-events: none;
    background: linear-gradient(90deg, red 0, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, red);
`;

export const CSSColorRangePicker = styled.div<{ size: number; backgroundColor: string; top: number; left: number }>`
    width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;
    pointer-events: none;
    position: absolute;
    margin-left: -${(props) => props.size / 2}px;
    border-width: 2px;
    border-color: ${(props) => props.theme.color.white};
    border-style: solid;
    border-radius: ${(props) => props.size}px;
    background-color: ${(props) => props.backgroundColor};
    top: ${(props) => props.top}px;
    left: ${(props) => props.left}px;
`;

export const ColorRange = ({
    width = 400,
    hue,
    onChange,
}: {
    width: number;
    hue: number;
    onChange: (color: string, hue: number, mouseIsDown: boolean) => void;
}) => {
    const [picker, setPicker] = React.useState<Vector>({ x: 0, y: 0 });
    const [pickerColor, setPickerColor] = React.useState<string>('');

    React.useEffect(() => {
        const x = (hue * width) / 360;
        setPicker({ x, y: 0 });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        const hue = Math.floor((picker.x * 359) / width);
        const hex = colorimetry.hsl(hue, 100, 50).toHex().string();
        setPickerColor(hex);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [picker]);

    return (
        <DragArea
            width={width}
            height={RANGE_HEIGHT}
            initialPosition={picker}
            onChange={(picker, mouseIsDown) => {
                const hue = Math.floor((picker.x * 359) / width);
                const hex = colorimetry.hsl(hue, 100, 50).toHex().string();
                setPicker(picker);
                onChange(hex, hue, mouseIsDown);
            }}>
            <CSSColorRangeWrapper>
                <CSSColorRangeBackground width={width} height={RANGE_HEIGHT} />
                <CSSColorRangePicker size={RANGE_HEIGHT} backgroundColor={pickerColor} top={0} left={picker.x} />
            </CSSColorRangeWrapper>
        </DragArea>
    );
};
